const LoginAlert = ({ onCancel, onNext }) => {
  return (
    <div className="w-[360px] p-5 bg-primary-medium flex flex-col gap-6 text-sm items-center">
      <div className="font-extrabold text-xl leading-6 text-center">Thông báo</div>
      <div className="font-extrabold opacity-70">Bạn cần đăng nhập để sử dụng tính năng này</div>
      <div className="flex items-center font-bold w-full">
        <button className="grow" onClick={onCancel}>
          Hủy
        </button>
        <button className="grow bg-primary rounded-[100px] py-2 text-sm text-white" onClick={onNext}>
          Đăng nhập
        </button>
      </div>
    </div>
  )
}

export default LoginAlert
